import { GET_ALL_LUNCH, GET_NEXT_LUNCH_DATE } from "@/GraphQL/Queries";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import React, { useState } from "react";
import { Badge, Button, Card, CardBody, Col, Row, Table } from "reactstrap";
import { Pagination } from "@mui/material";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import { DELETE_LUNCH_PULL, UPDATE_LUNCH_PULL } from "@/GraphQL/Mutation";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import LunchModal from "./LunchModal";
import imageUrl from "@/utils/api/imageUrl";
export default function LunchList() {
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 30;
  const [editModalOpen, setEditModalOpen] = useState(false);
  const closeEditModal = () => {
    setEditModalOpen(false);
  };
  const { data: nextDate, loading: nextLoading } =
    useQuery(GET_NEXT_LUNCH_DATE);

  const [lunchDate, setLunchDate] = useState("");
  const { data, loading, error, refetch } = useQuery(GET_ALL_LUNCH, {
    variables: {
      lunch_date: lunchDate || undefined,
      page: currentPage,
      size: limit,
      // has_lunch: true,
    },
    fetchPolicy: "network-only",
  });

  React.useEffect(() => {
    if (nextDate?.getNextLunchDate?.lunch_date) {
      const formatted = moment(nextDate.getNextLunchDate.lunch_date).format(
        "YYYY-MM-DD"
      );
      setLunchDate(formatted);
      refetch({
        lunch_date: formatted,
        page: 1,
        size: limit,
      });
    }
  }, [nextDate?.getNextLunchDate?.lunch_date]);
  const handleChange = (e, p) => {
    setCurrentPage(p);
    refetch({
      page: p,
    });
  };
  const [updateLunchPull, { loading: submitLoading }] =
    useMutation(UPDATE_LUNCH_PULL);

  const [deleteLunchPull, { loading: deleteLoading }] =
    useMutation(DELETE_LUNCH_PULL);

  const openModal = async (userItem) => {
    const alreadyHasLunch = userItem?.has_lunch === true;
    const actionText = alreadyHasLunch ? "Remove Lunch?" : "Add Lunch?";
    const confirmText = alreadyHasLunch ? "Yes, remove it!" : "Yes, add it!";
    const successMessage = alreadyHasLunch
      ? "Lunch pull removed successfully!"
      : "Lunch pull added successfully!";
    const updatedHasLunch = !alreadyHasLunch;

    const result = await Swal.fire({
      title: actionText,
      text: `Do you want to ${
        alreadyHasLunch ? "remove" : "add"
      } lunch for this user?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      let res;
      res = await deleteLunchPull({
        variables: {
          id: userItem.id,
        },
      });

      const resultCode = res?.data?.deleteLunchPull?.result_code;

      const status = res?.data?.updateLunchPull?.status;

      if (resultCode === "001") {
        Swal.fire("✅ Success", successMessage, "success");
        refetch();
      } else {
        Swal.fire("⚠️ Failed", status, "error");
        refetch();
      }
    } catch (err) {
      console.error("❌ Error toggling lunch pull:", err);
      Swal.fire("❌ Error", "An error occurred. Please try again.", "error");
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SubmitLoading color="black" />
      </div>
    );
  }
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Lunch List ",
    },
  ];
  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <BreadCrumb breadCrumbData={breadCrumbData} />
          </Col>
        </Row>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0"> Lunch Pulled History</h4>
          <div className="d-flex align-items-center gap-2">
            <span className="mx-2 fw-bold">Filter by Date:</span>
            {/* <DatePicker
              selected={lunchDate ? new Date(lunchDate) : null}
              onChange={(date) => {
                setLunchDate(date ? moment(date).format("YYYY-MM-DD") : "");
                setCurrentPage(1);
                refetch({
                  lunch_date: date
                    ? moment(date).format("YYYY-MM-DD")
                    : undefined,
                  page: 1,
                  size: limit,
                });
              }}
              dateFormat="dd MMMM, yyyy"
              isClearable
              className="form-control me-10"
              placeholderText="Select Date"
            /> */}
            {/* <DatePicker
              selected={lunchDate ? new Date(lunchDate) : null}
              onChange={(date) => {
                setLunchDate(date ? moment(date).format("YYYY-MM-DD") : "");
                setCurrentPage(1);
                refetch({
                  lunch_date: date
                    ? moment(date).format("YYYY-MM-DD")
                    : undefined,
                  page: 1,
                  size: limit,
                });
              }}
              dateFormat="dd MMMM, yyyy"
              isClearable
              className="form-control"
              placeholderText="Select Date"
              popperPlacement="bottom-end"
            /> */}
            <DatePicker
              selected={lunchDate ? new Date(lunchDate) : null}
              onChange={(date) => {
                setLunchDate(date ? moment(date).format("YYYY-MM-DD") : "");
                setCurrentPage(1);
                refetch({
                  lunch_date: date
                    ? moment(date).format("YYYY-MM-DD")
                    : undefined,
                  page: 1,
                  size: limit,
                });
              }}
              dateFormat="dd MMMM, yyyy"
              // isClearable
              placeholderText="Select Date"
              popperPlacement="bottom-end"
              // className="form-control"
              style={{ fontSize: "12px", padding: "4px 8px", height: "32px" }} // <-- custom sizing
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-muted text-bold">
            Total Lunch: {data?.getAllLunch?.paginatorInfo?.total}
          </div>
          <p>
            Date :{" "}
            <span className="text-success text-bold">
              {moment(lunchDate).format("DD MMMM, YYYY")}
            </span>
          </p>
          <Button
            color="primary"
            size="sm"
            onClick={() => setEditModalOpen(true)}
          >
            Add Lunch
          </Button>
        </div>
        <Table bordered hover striped responsive size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Department</th>
              <th>Designation</th>
              <th>Email</th>
              <th>Lunch</th>
              {lunchDate === nextDate?.getNextLunchDate?.lunch_date && (
                <th>Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data?.getAllLunch?.data?.length > 0 ? (
              data?.getAllLunch?.data?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  {/* <td>
                    {item?.lunchDateInfo?.lunch_date
                      ? moment(item.lunchDateInfo.lunch_date).format(
                          "D MMMM, YYYY"
                        )
                      : "N/A"}
                  </td> */}
                  <td>
                    {" "}
                    <img
                      src={`${imageUrl}/users/${
                        item?.userInfo?.images ||
                        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                      }`}
                      alt="Profile"
                      onError={(e) => {
                        e.target.src =
                          "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                      }}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "3px solid #f0f0f0",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      }}
                    />
                  </td>
                  <td>{item?.userInfo?.name || "N/A"}</td>
                  <td>
                    {item?.userInfo?.departments?.length
                      ? item.userInfo.departments?.map((d) => d.name).join(", ")
                      : "N/A"}
                  </td>
                  <td>
                    {item?.userInfo?.additionalInfo?.designationInfo?.name ||
                      "N/A"}
                  </td>
                  <td>{item?.userInfo?.email || "N/A"}</td>
                  <td>
                    {item?.has_lunch ? (
                      <span className="text-success fw-bold">✅ Yes</span>
                    ) : (
                      <span className="text-danger fw-bold">❌ No</span>
                    )}
                  </td>

                  {lunchDate === nextDate?.getNextLunchDate?.lunch_date ? (
                    // <Button
                    //   //   color="primary"
                    //   size="sm"
                    //   onClick={() => openModal(item)}
                    // >
                    //   update Lunch
                    // </Button>
                    // <Badge
                    //   onClick={() => openModal(item)}
                    //   className="text-white m-1"
                    //   color={"primary"}
                    // >
                    //   Update
                    // </Badge>
                    <button
                      className="inbox__email-btn mr-1"
                      type="button"
                      aria-label="edit"
                      onClick={() => openModal(item)}
                    >
                      <EditIcon fontSize="small" />
                    </button>
                  ) : null}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {data?.getAllLunch?.data.length > 0 ? (
          <Pagination
            className="mt-2"
            count={data?.getAllLunch?.paginatorInfo?.lastPage}
            page={data?.getAllLunch?.paginatorInfo?.currentPage}
            onChange={handleChange}
          />
        ) : null}
        <LunchModal
          modal={editModalOpen}
          refetch={refetch}
          toggle={closeEditModal}
        />
      </CardBody>
    </Card>
  );
}
